import React from 'react';

const ArrowDown = () => {
  return (
    <svg viewBox="0 0 41 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-700.000000, -976.000000)">
        <g transform="translate(668.000000, 944.000000)">
          <path d="M41.736,42.1586826 L59.6453333,24.2365269 C60.688,23.254491 62.2826667,23.254491 63.264,24.2365269 C64.2453333,25.2185629 64.2453333,26.8143713 63.264,27.8577844 L47.1333333,44 L63.264,60.1422156 C64.2453333,61.1242515 64.2453333,62.7814371 63.264,63.7634731 C62.2826667,64.745509 60.688,64.745509 59.6453333,63.7634731 L41.736,45.7799401 C40.7546667,44.7979042 40.7546667,43.2020958 41.736,42.1586826" id="Arrow" transform="translate(52.500000, 44.000000) rotate(-90.000000) translate(-52.500000, -44.000000) "></path>
        </g>
      </g>
    </svg>
  )
}

export default ArrowDown
